import React from 'react';
import { Link } from 'react-router-dom';
import {
    useCartContext,
    useModalsContext,
    useStoreConfigContext
} from '/src/providers';
import {
    Modal,
    Form,
    useForm,
    FORM_VALIDATORS,
    H2,
} from '/src/components';
import { CREATE_ACCOUNT } from '/src/consts';
import * as styles from './styles.scss';

const VipAccount = ({ setIsVip, setIsGuestContinue, title = 'Create a VIP account' }) => {
    const { translate } = useStoreConfigContext();
    const { hideModal, showModal, MODALS_TYPES } = useModalsContext();
    const { cart: { email } } = useCartContext();
    const {
        data,
        fieldsErrors,
        handleChange,
        validateData,
    } = useForm(
        {
            password: '',
            confirmPassword: '',
        },
        {
            password: {
                isRequired: true,
                validator: FORM_VALIDATORS.password,
            },
            confirmPassword: {
                isRequired: true,
                validator: FORM_VALIDATORS.sameAsField,
                field: 'password'
            }
        }
    );

    const handleSubmit = e => {
        e.preventDefault();
        const isValidData = validateData();
        const { password } = data;

        if (isValidData) {
            const accountData = JSON.parse(sessionStorage.getItem(CREATE_ACCOUNT));
            const newAccountData = { email, password };

            sessionStorage.setItem(CREATE_ACCOUNT, JSON.stringify({ ...accountData, ...newAccountData }));
            setIsVip(true);
            showModal(MODALS_TYPES.SUCCESS);
        }
    };

    return (
        <Modal toggle={hideModal} login>
            <H2>{translate(title)}</H2>
            <Form onSubmit={handleSubmit}>
                <Form.Column mb mt>
                    <div className={styles.row}>
                        <Form.Input
                            label={translate('Email')}
                            type="email"
                            name="email"
                            value={email}
                            disabled
                        />
                        <Link
                            className={styles.link}
                            to="/checkout"
                            onClick={
                                () => {
                                    setIsGuestContinue(false);
                                    hideModal();
                                }
                            }
                        >
                            {translate('Change')}
                        </Link>
                    </div>
                </Form.Column>
                <Form.Column mb>
                    <Form.Input
                        label={translate('Password')}
                        type="password"
                        name="password"
                        value={data.password}
                        onChange={handleChange}
                        error={translate(fieldsErrors.password)}
                        autoComplete="current-password"
                    />
                </Form.Column>
                <Form.Column>
                    <Form.Input
                        label={translate('Confirm password')}
                        type="password"
                        name="confirmPassword"
                        value={data.confirmPassword}
                        onChange={handleChange}
                        error={translate(fieldsErrors.confirmPassword)}
                        autoComplete="current-password"
                    />
                </Form.Column>
                <Form.Column mt>
                    <Form.Button>
                        {translate('Continue')}
                    </Form.Button>
                </Form.Column>
            </Form>
        </Modal>
    )
};

export default VipAccount;
